import { useMemo } from 'react'
import { Theme } from '@mui/material/styles'
import useTheme from '@mui/material/styles/useTheme'

export function useCreateNewStyles() {
  const theme = useTheme()

  const gutter = useMemo(() => Number.parseInt(theme.spacing(2)), [theme])
  const styles = getStyles(theme)
  return { styles, gutter }
}

const getStyles = (theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(4),
    flexGrow: 1,
    overflow: 'hidden auto',
  },

  header: {
    fontFamily: 'Source Sans Pro SemiBold',
    fontSize: '22px',
  },

  billTo: {
    marginTop: theme.spacing(1),
  },

  masonry: {
    paddingTop: theme.spacing(0.4),
    paddingLeft: theme.spacing(0.4),
    marginTop: `calc(${theme.spacing(1)} - 4px)`,
    marginLeft: `calc(${theme.spacing(2)} - 4px)`,
  },
})
